export const initialState = {
    loading: false,
    data: null,
    dataError: null,
    error: false,
    isUpdateLoading: false,
    isUpdateSuccess: false,
    isUpdateError: false
};

export const url = {
    getReservationListSeller: () => '/api/reservations/seller',
    updateReservationSeller: id => `/api/reservations/seller/${id}`
};

export const TYPE = {
    getReservationListSeller: 'GET_RESERVATION_LIST_SELLER',
    updateReservation: 'UPDATE_RESERVATION_SELLER',
    resetReservationListSeller: 'RESET_RESERVATION_LIST_SELLER'
};

export default (state = initialState, action) => {
    switch (action.type) {
        case `RECEIVE_${TYPE.getReservationListSeller}`:
            return {
                ...state,
                loading: false,
                data: action.data,
                error: false
            };
        case `ERROR_${TYPE.getReservationListSeller}`:
            return {
                ...state,
                loading: false,
                error: true,
                data: null,
                dataError: action.data
            };
        case `REQUEST_${TYPE.getReservationListSeller}`:
            return {
                ...state,
                loading: true,
                error: false,
                data: null
            };
        case `RECEIVE_${TYPE.updateReservation}`:
            return {
                ...state,
                isUpdateLoading: false,
                isUpdateSuccess: true,
                isUpdateError: false
            };
        case `ERROR_${TYPE.updateReservation}`:
            return {
                ...state,
                isUpdateLoading: false,
                isUpdateError: true,
                isUpdateSuccess: false
            };
        case `REQUEST_${TYPE.updateReservation}`:
            return {
                ...state,
                isUpdateLoading: true,
                isUpdateError: false,
                error: false,
                isUpdateSuccess: false
            };
        case `RESPONSE_PATCH_${TYPE.updateReservation}`:
            return {
                ...state,
                isUpdateLoading: false,
                isUpdateSuccess: true,
                isUpdateError: false
            };
        case `ERROR_PATCH_${TYPE.updateReservation}`:
            return {
                ...state,
                isUpdateLoading: false,
                isUpdateError: true,
                isUpdateSuccess: false
            };
        case TYPE.resetReservationListSeller:
            return {
                ...state,
                loading: false,
                data: null,
                dataError: null,
                error: false,
                isUpdateLoading: false,
                isUpdateSuccess: false,
                isUpdateError: false
            };
        default:
            return state;
    }
};
